import React, { useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faEyeSlash, faEye, faLock } from '@fortawesome/free-solid-svg-icons';

type Props = {
  label?: Label | string;
  id?: string;
  name?: string;
  type?: string;
  value?: string;
  readOnly?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  autoComplete?: string;
  accessibility_id?: string;
  placeholder?: string;
  input?: {
    name?: string;
    value?: string;
  };
  meta?: {
    validating?: boolean;
    touched?: boolean;
    error: string;
    submitError?: string;
  };
  mask?: any;
  maskChar?: any;
  formatChars?: any;
  validatefield?: any;
  hasAsync?: boolean;
  className?: string;
  hasMask?: boolean;
  icon?: IconDefinition;
  showIconPassword?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit?: (event: React.FormEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

type Label = {
  label?: string;
  descricao?: string;
};

const Input: React.FC<Props> = props => {
  const {
    label,
    input,
    meta,
    className,
    value,
    hasAsync = false,
    hasMask = false,
    icon = null,
    showIconPassword = null,
    ...rest
  } = props;

  const { disabled } = props;

  let labelHasMask = null;
  let labelNotMask = null;

  if (typeof label === 'object') {
    labelHasMask = label;
  }

  if (typeof label === 'string') {
    labelNotMask = label;
  }

  let _value = null;

  if (hasMask) {
    _value = input.value;
  } else {
    _value = value || input.value;
  }
  const typeRef = useRef(null);
  const iconRef = useRef(null);
  const [typeState, setTypeState] = useState('password');

  const onClickIcon = string => {
    setTypeState(string);
    typeRef.current.type = string;
  };

  return (
    <div
      className={
        hasMask
          ? className
          : `form-group-input ${
              meta && (meta.error || meta.submitError) && 'is-invalid'
            }`
      }
    >
      {icon && <FontAwesomeIcon icon={icon} className="text-color-orange" />}
      {hasMask && !showIconPassword && (
        <>
          <InputMask
            {...input}
            {...rest}
            value={_value}
            id={input.name}
            className="form-group-field"
          />
          {labelHasMask && (
            <label htmlFor={input.name} className="form-group-label">
              {labelHasMask.label}{' '}
              {labelHasMask.descricao ? labelHasMask.descricao : ''}
            </label>
          )}
          {hasAsync && meta.validating && (
            <span className="is-loading-input form-control-feedback" />
          )}
          {(meta.error || meta.submitError) && meta.touched && (
            <span className="invalid-feedback">
              {meta.error || meta.submitError}
            </span>
          )}
        </>
      )}

      {(!hasMask || showIconPassword) && (
        <>
          <input
            ref={typeRef}
            {...input}
            {...rest}
            value={_value}
            id={input.name}
            className={`form-group-field ${icon && 'hasIcon-left'} ${
              disabled && 'hasIcon-right'
            }`}
          />
          {labelNotMask && (
            <label htmlFor={input.name} className="form-group-label">
              {labelNotMask}
            </label>
          )}
          {labelHasMask && (
            <label htmlFor={input.name} className="form-group-label">
              {labelHasMask.label}{' '}
              {labelHasMask.descricao ? labelHasMask.descricao : ''}
            </label>
          )}
          {hasAsync && <span className="is-loading-input form-control-feedback" />}
          {meta && (meta.error || meta.submitError) && (
            <span className="invalid-feedback">
              {meta.error || meta.submitError}
            </span>
          )}
          {disabled && (
            <FontAwesomeIcon
              icon={faLock}
              className="text-color-purple"
              style={{ right: '15px', left: 'unset', opacity: 0.6 }}
            />
          )}
        </>
      )}
      {typeState === 'password' && showIconPassword && (
        <span ref={iconRef}>
          <FontAwesomeIcon
            icon={faEyeSlash}
            className="text-color-orange"
            style={{ left: '90%' }}
            onClick={() => onClickIcon('text')}
          />
        </span>
      )}
      {typeState === 'text' && showIconPassword && (
        <span ref={iconRef}>
          <FontAwesomeIcon
            icon={faEye}
            className="text-color-orange"
            style={{ left: '90%' }}
            onClick={() => onClickIcon('password')}
          />
        </span>
      )}
    </div>
  );
};

export default Input;
